import resourcesToBackend from 'i18next-resources-to-backend';

import { lazyTranslationsRegistry } from '../registerLazyTranslations';

/**
 * i18next's default namespace. `initI18n` sets it, and i18next loads it on
 * init whatever the app asks for — so it reaches this backend even in an app
 * whose every screen uses a named namespace.
 */
const DEFAULT_NAMESPACE = 'translation';

const lazyBackend = resourcesToBackend(async (lng: string, ns: string) => {
  const loader = lazyTranslationsRegistry.get(ns);

  if (!loader) {
    // Nobody registers the default namespace: lazy apps keep their copy in
    // named ones. Apps that started from `initI18n({ de: { translation: {} } })`
    // never reached here for it, but the generator's lazy app root starts from
    // `{}`, so on every startup this used to throw — a failed load per
    // language, swallowed silently unless i18next debug is on (FE-2962).
    // Empty is the honest answer: there is nothing in it.
    if (ns === DEFAULT_NAMESPACE) {
      return {};
    }

    throw new Error(
      `i18n: no lazy loader registered for namespace "${ns}". Did you forget to import the module's i18n/index.ts, or is this namespace meant to be bundled eagerly via addTranslations?`,
    );
  }

  try {
    return await loader(lng);
  } catch (err) {
    console.warn(
      `i18n: failed to load translations for namespace "${ns}" (${lng})`,
      err,
    );
    return {};
  }
});

export default lazyBackend;
